<style>
  /*
   * Die Kapitelnummern stehen bereits im Text der &Uuml;berschriften.
   * Dadurch wird eine zus&auml;tzliche Nummerierung aus globalen CSS-Regeln verhindert.
   */
  .ktbl-help h2,
  .ktbl-help h3,
  .ktbl-help h4 {
    counter-increment: none !important;
  }

  .ktbl-help h2::before,
  .ktbl-help h3::before,
  .ktbl-help h4::before {
    content: none !important;
    display: none !important;
  }

  .ktbl-help [id] {
    scroll-margin-top: 6rem;
  }

  .ktbl-help-toc {
    margin: 1.5rem 0 2rem;
  }

  .ktbl-help-toc ul {
    margin: 0.35rem 0;
    padding-left: 1.5rem;
  }

  .ktbl-help-toc>ul {
    padding-left: 1.25rem;
  }

  .ktbl-help-toc li {
    margin: 0.3rem 0;
  }

  .ktbl-help-toc a {
    white-space: normal !important;
    overflow-wrap: anywhere;
  }

  /* Keine Aufz&auml;hlungszeichen im Inhaltsverzeichnis */
  .ktbl-help .ktbl-help-toc ul,
  .ktbl-help .ktbl-help-toc ol,
  .ktbl-help .ktbl-help-toc li {
    list-style: none !important;
  }

  .ktbl-help .ktbl-help-toc>ul {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .ktbl-help .ktbl-help-toc ul ul {
    margin-left: 0 !important;
    padding-left: 1.5rem !important;
  }

  .ktbl-help .ktbl-help-toc li::marker {
    content: "" !important;
    font-size: 0 !important;
  }

  .ktbl-help .ktbl-help-toc li::before {
    content: none !important;
    display: none !important;
  }
</style>



<div class="ktbl-spacer-top-bottom">
</div>
<div class="ktbl-container">











  <article class="ktbl-help">
    <h1>
      Anleitung
    </h1>
    <h2 id="inhaltsverzeichnis">
      Inhaltsverzeichnis
    </h2>
    <nav aria-labelledby="inhaltsverzeichnis" class="ktbl-help-toc">
      <ul>
        <li>
          <a href="hilfe#1-uebersicht-zum-abstandsrechner">
            1. &Uuml;bersicht zum Abstandsrechner
          </a>
          <ul>
            <li>
              <a href="hilfe#1-1-abstand-fuer-eine-vorgegebene-immissionshaeufigkeit-berechnen">
                1.1 Abstand f&uuml;r eine vorgegebene Immissionsh&auml;ufigkeit berechnen
              </a>
            </li>
            <li>
              <a href="hilfe#1-2-geltungsbereich-der-abstandsregelung">
                1.2 Geltungsbereich der Abstandsregelung
              </a>
            </li>
            <li>
              <a href="hilfe#1-3-nichteinhalten-des-richtlinienabstandes-einzelfallbeurteilung">
                1.3 Nichteinhalten des Richtlinienabstandes &ndash; Einzelfallbeurteilung
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="hilfe#2-anwendungsmoeglichkeiten-des-abstandsrechners-fuer-verschiedene-aufgabenstellungen">
            2. Anwendungsm&ouml;glichkeiten des Abstandsrechners f&uuml;r verschiedene Aufgabenstellungen
          </a>
          <ul>
            <li>
              <a href="hilfe#2-1-beurteilung-einzelbetrieblicher-stallbauvorhaben">
                2.1 Beurteilung einzelbetrieblicher Stallbauvorhaben
              </a>
            </li>
            <li>
              <a href="hilfe#2-2-kommunale-bauleitplanung">
                2.2 Kommunale Bauleitplanung
              </a>
            </li>
            <li>
              <a href="hilfe#2-3-konfliktanalyse">
                2.3 Konfliktanalyse
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="hilfe#3-anwendung-des-abstandsrechners">
            3. Anwendung des Abstandsrechners
          </a>
          <ul>
            <li>
              <a href="hilfe#3-1-allgemeine-hinweise">
                3.1 Allgemeine Hinweise
              </a>
            </li>
            <li>
              <a href="hilfe#3-2-betrieb-angaben-zu-emissionsquellen-und-emissionsrelevante-daten">
                3.2 Betrieb: Angaben zu Emissionsquellen und emissionsrelevante Daten
              </a>
              <ul>
                <li>
                  <a href="hilfe#3-2-1-stallquellen">
                    3.2.1 Stallquellen
                  </a>
                </li>
                <li>
                  <a href="hilfe#3-2-2-flaechenquellen">
                    3.2.2 Fl&auml;chenquellen
                  </a>
                </li>
                <li>
                  <a href="hilfe#3-2-3-sonstige-quellen">
                    3.2.3 Sonstige Quellen
                  </a>
                </li>
                <li>
                  <a href="hilfe#3-2-4-zusatzabstand-und-gewichtungsfaktor-pruefen">
                    3.2.4 Zusatzabstand und Gewichtungsfaktor pr&uuml;fen
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a
                href="hilfe#3-3-winddaten-und-gebietskategorie-angaben-zur-windhaeufigkeit-und-zulaessigen-geruchsstundenhaeufigkeit-am-standort">
                3.3 Winddaten und Gebietskategorie: Angaben zur Windh&auml;ufigkeit und zul&auml;ssigen
                Geruchsstundenh&auml;ufigkeit am Standort
              </a>
            </li>
            <li>
              <a href="hilfe#3-4-ergebnisse-der-abstandsberechnung">
                3.4 Ergebnisse der Abstandsberechnung
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <h2 id="zusammenfassung">
      Zusammenfassung
    </h2>
    <ul>
      <li>
        Die Dateneingabe zur Berechnung des Richtlinienabstandes erfolgt
        &uuml;ber das Eingabeblatt &bdquo;Betrieb&ldquo; (Angaben zu Emissionsquellen und
        emissionsrelevante Daten) und das Eingabeblatt &bdquo;Winddaten und
        Gebietskategorie&ldquo; (Angaben zur Windh&auml;ufigkeit und zul&auml;ssigen
        Geruchsstundenh&auml;ufigkeit am Standort)
      </li>
      <li>
        Die Daten betriebsspezifischer Berechnungen k&ouml;nnen im JSON-Format
        exportiert, lokal gespeichert und wieder importiert werden, um als
        Vorlage f&uuml;r die Berechnung von Varianten zu dienen.
      </li>
      <li>
        Felder in roter Schrift sind Pflichtfelder.
      </li>
      <li>
        Wichtige Begriffe und Informationen werden direkt mit
        Mauszeigertexten (i) erl&auml;utert.
      </li>
      <li>
        In den Ergebnistabellen werden Werte au&szlig;erhalb des
        Geltungsbereichs der Richtlinie (z.B. Windh&auml;ufigkeit &gt; 60 &permil; oder
        Abst&auml;nde &lt; 50 m) in roter Schrift hervorgehoben.
      </li>
      <li>
        Das KTBL hat 2012 die Schrift &bdquo;Emissionen und Immissionen von Tierhaltungsanlagen &ndash; Handhabung der
        Richtlinie VDI 3894&ldquo; herausgegeben. Die Schrift wurde aus dem Verkauf genommen, die f&uuml;r die Anwendung
        des Geruchs-Abstandsrechners relevanten Passagen sind weiterhin g&uuml;ltig und k&ouml;nnen
        <button type="button" class="ktbl-button-download-link" (click)="downloadFileVdiAuszugPdf()">
          hier
          (
          <i class="
      fas
      fa-download
      ml-1
      download-info
      ktbl-icon-vertical-align
    "></i>
          {{ fileAppMetaDatas.vdiAuszugPdf.endungText }}-Download
          {{ fileAppMetaDatas.vdiAuszugPdf.sizeString }}
          )
        </button>

        kostenlos heruntergeladen werden.
      </li>
    </ul>
    <h2 id="1-uebersicht-zum-abstandsrechner">
      1. &Uuml;bersicht zum Abstandsrechner
    </h2>
    <p>
      Der Geruchs-Abstandsrechner &ndash; nach VDI 3894/2 &ndash; kurz
      &bdquo;Abstandsrechner&ldquo; &ndash; ist eine datenbankgest&uuml;tzte Web-Anwendung auf
      Grundlage der Richtlinie VDI 3894 Blatt 2 &bdquo;Emissionen und Immissionen
      aus Tierhaltungsanlagen &ndash; Methode zur Abstandsbestimmung &ndash; Geruch&ldquo; zur
      Beurteilung der Geruchsimmissionen im Umfeld von Tierhaltungsanlagen.
      Mit dem Abstandsrechner kann der Richtlinienabstand zwischen
      Tierhaltungsanlagen und anderen Nutzungen berechnet werden, der zum
      Schutz vor erheblichen Geruchsbel&auml;stigungen eingehalten werden sollte.
      Er kann als Referenzverfahren herangezogen werden.
    </p>
    <p>
      Der Richtlinienabstand h&auml;ngt ab von
    </p>
    <ul>
      <li>
        der H&ouml;he der Geruchsstoffemissionen,
      </li>
      <li>
        der Fl&auml;chenausdehnung der Tierhaltungsanlage oder bei zentraler
        Abluftf&uuml;hrung der genaue Abluftpunkt,
      </li>
      <li>
        der Windrichtungsh&auml;ufigkeit in Richtung der zu beurteilenden
        Immissionsorte &ndash; also potenziell von Geruchsimmissionen betroffenen
        Wohnbebauungen,
      </li>
      <li>
        der Gebietskategorie (Wohngebiet, Dorfgebiet etc.), der eine
        Nutzung zugeordnet werden kann bzw. dem Immissionswert nach Anhang 7 der
        TA Luft (ehemalige Geruchsimmissions-Richtlinie &ndash; GIRL) in Form von
        Geruchsstundenh&auml;ufigkeiten und
      </li>
      <li>
        dem tierartspezifischen Gewichtungsfaktor nach Anhang 7 der TA
        Luft, mit dem die unterschiedliche Bel&auml;stigungswirkung der Tierarten
        (insb. Rinder, Schweine, Gefl&uuml;gel) bei der Abstandsbemessung
        ber&uuml;cksichtigt wird.
      </li>
    </ul>
    <p>
      Die entsprechenden Daten f&uuml;r diese Parameter m&uuml;ssen bekannt sein und
      eingegeben werden.
    </p>
    <p>
      Eingabedaten und Berechnungsergebnisse k&ouml;nnen als PDF- oder
      Excel-Datei gespeichert und in andere Anwendungen (Tabellenkalkulation,
      Textverarbeitung) weiterbearbeitet werden. Gespeicherte Eingabedaten von
      Betrieben k&ouml;nnen f&uuml;r weitere Berechnungen eingelesen werden.
    </p>
    <p>
      Alle Grundlageninformationen zur Abstandsregelung enth&auml;lt die
      Richtlinie VDI 3894 Blatt 2. Die Richtlinie muss f&uuml;r eine rechtssichere
      Anwendung vorliegen.
    </p>
    <p>
      Dar&uuml;ber hinaus bietet die 2012 ver&ouml;ffentlichte KTBL-Schrift
      &bdquo;Emissionen und Immissionen von Tierhaltungsanlagen &ndash; Handhabung der
      Richtlinie VDI 3894&ldquo; Hintergrundinformationen, die f&uuml;r ein vertieftes
      Verst&auml;ndnis und die richtige Anwendung der Richtlinie nach wie vor
      hilfreich sind.
    </p>
    <h3 id="1-1-abstand-fuer-eine-vorgegebene-immissionshaeufigkeit-berechnen">
      1.1 Abstand f&uuml;r eine vorgegebene Immissionsh&auml;ufigkeit berechnen
    </h3>
    <p>
      Die Ermittlung des Richtlinienabstands gegen&uuml;ber schutzbed&uuml;rftigen
      Nutzungen im Umfeld von Tierhaltungsanlagen ist der h&auml;ufigste
      Anwendungsfall der Abstandsregelung der Richtlinie VDI 3894 Blatt 2.
      Dazu m&uuml;ssen Art und Umfang der Tierhaltung bzw. deren Emissionen bekannt
      sein.
    </p>
    <p>
      Die Nutzungsarten der relevanten Immissionsorte im Umfeld bestimmen
      die zul&auml;ssige, bel&auml;stigungsrelevante Geruchsstundenh&auml;ufigkeit, bei dem
      die von Anhang 7 der TA Luft vorgegebenen Immissionswerte eingehalten
      werden. Die jeweilige Tierart bestimmt den tierartspezifischen
      Gewichtungsfaktor und aus der Lage des Immissionsortes ergibt sich die
      relevante Windrichtung, sodass die ma&szlig;gebliche Windrichtungsh&auml;ufigkeit
      aus meteorologischen Daten ermittelt werden kann. Damit sind die
      entscheidenden Eingangsgr&ouml;&szlig;en der Abstandsfunktion bekannt, sodass der
      Richtlinienabstand unmittelbar berechnet werden kann.
    </p>
    <p>
      In der Berechnung ist auf die richtige Wahl der vorgegebenen
      Einheiten zu achten: Die Geruchsstoffemission ist in Geruchseinheiten je
      Sekunde (GE/s), die Windrichtungsh&auml;ufigkeit in Promille (&permil;) bei einer
      36-teiligen Windrose und die bel&auml;stigungsrelevante
      Geruchsstundenh&auml;ufigkeit nach Anhang 7 der TA Luft in Prozent (%)
      anzugeben.
    </p>
    <h3 id="1-2-geltungsbereich-der-abstandsregelung">
      1.2 Geltungsbereich der Abstandsregelung
    </h3>
    <p>
      Der Geltungsbereich der Abstandsregelung wurde in der Richtlinie
      beschr&auml;nkt auf
    </p>
    <ul>
      <li>
        Geruchsstoffemissionen bis zu 50.000 GE/s,
      </li>
      <li>
        Windrichtungsh&auml;ufigkeiten der f&uuml;r die Abstandsbestimmung
        ma&szlig;geblichen Sektoren bis zu 60 &permil; (bei einer 36-teiligen
        Windrose),
      </li>
      <li>
        Geruchsstundenh&auml;ufigkeiten der Immission von 7 bis 40 %,
      </li>
      <li>
        Abst&auml;nde von 50 m oder mehr, die sich aus dieser Abstandsregelung
        ergeben, und
      </li>
      <li>
        Anlagen eines Betreibers; die kumulierende Wirkung von
        benachbarten Anlagen kann nur bedingt ber&uuml;cksichtigt werden.
      </li>
    </ul>
    <p>
      Die Einschr&auml;nkungen ergeben sich zum Teil aus den bei der Herleitung
      der Abstandsregelung gew&auml;hlten Randbedingungen der
      Ausbreitungsberechnungen. Dabei wurden nur Quellst&auml;rken bis maximal
      50.000 GE/s ber&uuml;cksichtigt. Dabei zeigte sich auch, dass die
      Abstandsfunktion f&uuml;r Windrichtungsh&auml;ufigkeiten &uuml;ber 60 &permil; keinen
      hinreichend konservativen Wert mehr liefert. Die Untergrenze f&uuml;r die
      Geruchsstundenh&auml;ufigkeit wurde auf 70 &permil; bzw. 7 % festgelegt, da bei
      kleineren H&auml;ufigkeiten und h&ouml;heren Quellst&auml;rken zu wenige Daten
      innerhalb des Rechengebietes verf&uuml;gbar und auswertbar waren.
    </p>
    <p>
      Die Abstandsfunktion gilt unter den zugrunde gelegten
      Standardbedingungen einer vertikalen Linienquelle grunds&auml;tzlich ohne
      Einschr&auml;nkung auch f&uuml;r den Nahbereich der Quelle. In der Praxis werden
      die Str&ouml;mungsverh&auml;ltnisse im Nahbereich jedoch wesentlich durch die
      Umstr&ouml;mung der Stallgeb&auml;ude beeinflusst, was in der Abstandsregelung
      nicht allgemein ber&uuml;cksichtigt werden kann. Der Abstandsrechner sollte
      daher nur f&uuml;r Abst&auml;nde &uuml;ber 50 m angewendet werden.
    </p>
    <p>
      Generell gilt, dass alle F&auml;lle, auf die das
      Standard-Ausbreitungsmodell AUSTAL nicht anwendbar sind, auch nicht mit
      der Abstandsregelung dieser Richtlinie beurteilt werden sollen, z. B.
      bei Vorliegen besonderer Gel&auml;ndebedingungen. Derartige Konstellationen
      k&ouml;nnen nur mit speziellen Modellen beurteilt werden.
    </p>
    <p>
      Grunds&auml;tzlich gilt jedoch, dass dem Abstandsmodell der VDI 3894 Blatt
      2 eine stetige Funktion zugrunde liegt und daher auch Eingabedaten
      au&szlig;erhalb des Geltungsbereichs zu grunds&auml;tzlich plausiblen Ergebnissen
      f&uuml;hren. Daher kann im Einzelfall eine Anwendung der Abstandsregelung
      auch au&szlig;erhalb des in der Richtlinie festgelegten Geltungsbereichs
      sinnvoll und angebracht sein. F&uuml;r die Praxis bedeutet dies, dass die
      Abstandsregelung zum Beispiel auch f&uuml;r Windrichtungsh&auml;ufigkeiten &uuml;ber 60
      &permil; eingesetzt werden kann. Allerdings erh&ouml;ht sich in diesem Fall die
      Wahrscheinlichkeit, dass der zum Schutz vor erheblichen
      Geruchsbel&auml;stigungen erforderliche Abstand im Vergleich zu
      Prognoseberechnungen untersch&auml;tzt wird.
    </p>
    <h3 id="1-3-nichteinhalten-des-richtlinienabstandes-einzelfallbeurteilung">
      1.3 Nichteinhalten des Richtlinienabstandes &ndash; Einzelfallbeurteilung
    </h3>
    <p>
      Werden die berechneten Abst&auml;nde nicht eingehalten, so bedeutet dies
      nicht, dass die tats&auml;chlich zu erwartende Belastung zu hoch und damit
      das Vorhaben nicht genehmigungsf&auml;hig w&auml;re. Im Allgemeinen ist die
      Beurteilung einer Immissionssituation auf Grundlage der Abstandsregelung
      der VDI 3894 Blatt 2 ausreichend konservativ, sodass die tats&auml;chliche
      Geruchsbelastung &uuml;bersch&auml;tzt wird.
    </p>
    <p>
      In diesem Fall k&ouml;nnen im Rahmen einer Einzelfallbeurteilung durch
      einen Sachverst&auml;ndigen differenziertere Beurteilungsmethoden wie
      Ausbreitungsrechnungen, Messungen oder Begehungen zur Ermittlung der
      Geruchsimmissionen eingesetzt werden, die ein realistisches Bild
      ergeben.
    </p>
    <h2 id="2-anwendungsmoeglichkeiten-des-abstandsrechners-fuer-verschiedene-aufgabenstellungen">
      2. Anwendungsm&ouml;glichkeiten des Abstandsrechners f&uuml;r verschiedene Aufgabenstellungen
    </h2>
    <p>
      Die Berechnung des Richtlinienabstandes f&uuml;r einen vorgegebenen
      Immissionswert kann insbesondere
    </p>
    <ul>
      <li>
        f&uuml;r die Beurteilung einzelbetrieblicher
        Stallbauvorhaben,
      </li>
      <li>
        die kommunale Bauleitplanung und
      </li>
      <li>
        die Aufkl&auml;rung von Nachbarschaftskonflikten
      </li>
    </ul>
    <p>
      hilfreich sein.
    </p>
    <h3 id="2-1-beurteilung-einzelbetrieblicher-stallbauvorhaben">
      2.1 Beurteilung einzelbetrieblicher Stallbauvorhaben
    </h3>
    <p>
      Soll eine Tierhaltungsanlage neu errichtet werden, kann mithilfe der
      Richtlinie VDI 3894 Blatt 2 bzw. des Abstandsrechners derjenige Abstand
      zur n&auml;chstgelegenen empfindlichen (Wohn-)Nutzung ermittelt werden, bei
      dem die von Anhang 7 der TA Luft vorgegebenen Immissionswerte der
      Geruchsstundenh&auml;ufigkeit eingehalten werden. Erhebliche und damit
      unzumutbare Geruchsbel&auml;stigungen im Sinne des
      Bundes-Immissionsschutzgesetzes (BlmSchG) k&ouml;nnen in diesem Fall
      ausgeschlossen werden. Andere Geruchsquellen sind gegebenenfalls als
      Vorbelastung zu ber&uuml;cksichtigen. Bei &Auml;nderung oder Erweiterung von
      Tierhaltungen ist dabei der gesamte Betrieb zu ber&uuml;cksichtigen.
    </p>
    <p>
      Stellt sich heraus, dass der ermittelte Abstand den Vorgaben des Anhang 7 der TA Luft nicht gen&uuml;gt, ist zu
      erw&auml;gen, ob der Standort des Bauvorhabens oder einzelne Emissionsquellen auf dem Betriebsgel&auml;nde verlegt
      oder abgekoppelt werden k&ouml;nnen. Denkbar ist auch die Verkleinerung oder komplette Auslagerung von
      Betriebsteilen oder der Einsatz technischer Zusatzma&szlig;nahmen wie Abluftreinigungsanlagen. Um ein solches
      Vorhaben jedoch differenziert beurteilen zu k&ouml;nnen, wird in der Regel eine Ausbreitungsrechnung mit AUSTAL
      notwendig sein. Das Rechenprogramm AUSTAL kann auf den
      <a href="https://www.umweltbundesamt.de/themen/luft/regelungen-strategien/ausbreitungsmodelle-fuer-anlagenbezogene/download-0"
        rel="noopener noreferrer" target="_blank">
        Webseiten des Umweltbundesamtes
      </a>
      heruntergeladen werden.
    </p>
    <h3 id="2-2-kommunale-bauleitplanung">
      2.2 Kommunale Bauleitplanung
    </h3>
    <p>
      Im Rahmen der kommunalen Bauleitplanung sind die Gemeinden nach
      Ma&szlig;gabe des &sect; 1 Abs. 7 BauGB gehalten, &bdquo;&hellip; bei der Aufstellung der
      Bauleitpl&auml;ne (&hellip;) die &ouml;ffentlichen und privaten Belange gegeneinander und
      untereinander gerecht abzuw&auml;gen&ldquo;. Will die Gemeinde also ein Wohngebiet
      im Einwirkungsbereich einer Tierhaltungsanlage ausweisen oder ein
      Dorfgebiet festsetzen, hat sie die Belange der Wohnbev&ouml;lkerung und die
      der Landwirtschaft gegeneinander abzuw&auml;gen. In die Abw&auml;gung sind dabei
      nicht nur der Schutz der Wohnnutzung vor unzumutbaren Immissionen aus
      der Landwirtschaft wie Geruchs- und L&auml;rmbel&auml;stigungen einzustellen.
      Vielmehr sind auf Seiten der Landwirtschaft die langfristige
      Betriebsentwicklung, die Wirtschaftskraft des Betriebes,
      Erweiterungsm&ouml;glichkeiten sowie der Fl&auml;chenbesatz f&uuml;r die Tierhaltung in
      die Planungsentscheidung einzubeziehen.
    </p>
    <p>
      Um sich dabei einen ersten &Uuml;berblick &uuml;ber das Verh&auml;ltnis von
      Bauleitplanung und Geruchsbelastung zu verschaffen, bietet sich ein
      R&uuml;ckgriff auf das Abstandsmodell der Richtlinie VDI 3894 an. Mithilfe
      des Abstandsrechners k&ouml;nnen auf einfache Art und Weise verschiedene
      Planungsalternativen durchgespielt und die jeweiligen
      &bdquo;Planungs&ldquo;-Abst&auml;nde mit den zu erwartenden Geruchsstundenh&auml;ufigkeiten in
      Relation gesetzt werden.
    </p>
    <h3 id="2-3-konfliktanalyse">
      2.3 Konfliktanalyse
    </h3>
    <p>
      Geruchsbel&auml;stigungen spielen nicht nur bei &ouml;ffentlich-rechtlichen
      Genehmigungsentscheidungen eine Rolle. Vielmehr k&ouml;nnen sie auch im
      nachbarschaftlichen Verh&auml;ltnis zu Streitigkeiten und
      Auseinandersetzungen f&uuml;hren. Im Mittelpunkt der Streitigkeiten steht
      dabei regelm&auml;&szlig;ig die Frage nach deren Zumutbarkeit. Sind die
      Geruchsbel&auml;stigungen der Nachbarin oder dem Nachbarn zumutbar, bleibt
      alles beim Alten. Sind sie jedoch unzumutbar, muss die Landwirtin oder
      der Landwirt mit dem Erlass nachtr&auml;glicher Auflagen durch die
      Genehmigungsbeh&ouml;rde rechnen &ndash; schlimmstenfalls droht eine
      zivilrechtliche Unterlassungsklage.
    </p>
    <p>
      Um in solchen F&auml;llen einen raschen Eindruck von der Geruchssituation
      zu erhalten, kann auf den Abstandsrechner zur&uuml;ckgegriffen werden. Wird
      ausgehend von den Immissionswerten des Anhang 7 der TA Luft im konkreten
      Einzelfall einzuhaltende Schutzabstand zwischen Tierhaltung und
      Wohnnutzung eingehalten, sind unzumutbare Geruchsbel&auml;stigungen im
      Regelfall auszuschlie&szlig;en, wenn keine anderen Geruchsquellen als
      Vorbelastung vorhanden sind. Werden die erforderlichen Abst&auml;nde nicht
      eingehalten, ist gem&auml;&szlig; Nr. 5 der Richtlinie VDI 3894 Blatt 2 nicht
      zwingend auf die Unzumutbarkeit der Geruchsimmissionen zu schlie&szlig;en. In
      diesem Fall k&ouml;nnen entweder weitere emissionsmindernde Ma&szlig;nahmen oder
      die Verlagerung von Emissionsquellen durchgef&uuml;hrt werden, um das
      Nachbarschaftsverh&auml;ltnis zu befrieden. Oder aber es k&ouml;nnen
      differenziertere Beurteilungsmethoden, z. B. eine Ausbreitungsrechnung
      mit AUSTAL oder Messungen und Begehungen, durchgef&uuml;hrt werden, um die
      tats&auml;chliche Geruchsbelastung zu ermitteln.
    </p>
    <h2 id="3-anwendung-des-abstandsrechners">
      3. Anwendung des Abstandsrechners
    </h2>
    <h3 id="3-1-allgemeine-hinweise">
      3.1 Allgemeine Hinweise
    </h3>
    <p>
      Nach Start des Abstandsrechners muss im Feld &bdquo;Projektbezeichnung&ldquo;
      beispielsweise ein Betriebsname f&uuml;r die Berechnungen eingegeben werden.
      Diese Eingabe wird als Dateiname mit dem Zusatz &bdquo;-Export&ldquo; f&uuml;r das lokale
      Abspeichern der Eingaben als JSON-Datei verwendet.
    </p>
    <p>
      Im optionalen Feld &bdquo;Projektbeschreibung&ldquo; k&ouml;nnen Anmerkungen, z. B.
      zur Variante der Berechnung, dokumentiert werden.
    </p>
    <p>
      Die Dateneingabe zur Berechnung des Richtlinienabstandes erfolgt &uuml;ber
      zwei Eingabebl&auml;tter (Reiter):
    </p>
    <ol type="1">
      <li>
        Betrieb (Angaben zu Emissionsquellen und emissionsrelevante
        Daten)
      </li>
      <li>
        Winddaten und Gebietskategorie (Angaben zur Windh&auml;ufigkeit und
        zul&auml;ssigen Geruchsstundenh&auml;ufigkeit am Standort)
      </li>
    </ol>
    <p>
      Verpflichtend auszuf&uuml;llende Eingabe- und Auswahlfelder sind mit roter
      Schrift gekennzeichnet.
    </p>
    <p>
      Die Daten betriebsspezifischer Berechnungen k&ouml;nnen im JSON-Format
      exportiert (Feld &bdquo;Betrieb exportieren&ldquo;), lokal gespeichert und wieder
      importiert (Feld &bdquo;Betrieb importieren&ldquo;) werden, um als Vorlage f&uuml;r die
      Berechnung von Varianten zu dienen.
    </p>
    <p>
      Wichtige Begriffe und Informationen werden direkt mit
      Mauszeigertexten (i) erl&auml;utert.
    </p>
    <p>
      Mit dem Button &bdquo;Entfernen der Quelldaten&ldquo; werden alle Eingaben im
      Reiter &bdquo;Betrieb&ldquo; unwiederbringlich gel&ouml;scht.
    </p>
    <h3 id="3-2-betrieb-angaben-zu-emissionsquellen-und-emissionsrelevante-daten">
      3.2 Betrieb: Angaben zu Emissionsquellen und emissionsrelevante Daten
    </h3>
    <p>
      &Uuml;ber &bdquo;+ Quelle hinzuf&uuml;gen&ldquo; k&ouml;nnen Emissionsquellen definiert werden.
      Es stehen drei Arten von Emissionsquellen zur Verf&uuml;gung:
    </p>
    <ul>
      <li>
        Stallquellen f&uuml;r verschiedene Tierarten (z. B. Schwein, Rind,
        Huhn) und Tierkategorien (z.B. Junghennen, Legehennen,
        Masth&uuml;hner)
      </li>
      <li>
        Fl&auml;chenquellen, z. B. G&uuml;llebeh&auml;lter, Fahrsiloanlagen und
        Festmistlager
      </li>
      <li>
        Sonstige Quellen, z. B. Biogas-BHKW
      </li>
    </ul>
    <p>
      Es k&ouml;nnen mehrere Quellen zu einer Gesamtanlage zusammengestellt
      werden. Jede Quelle kann &uuml;ber die Buttons &bdquo;Editieren&ldquo; und &bdquo;Entfernen&ldquo;
      bearbeitet oder gel&ouml;scht werden.
    </p>
    <h4 id="3-2-1-stallquellen">
      3.2.1 Stallquellen
    </h4>
    <p>
      Stallquellen k&ouml;nnen f&uuml;r Tierarten und Tierkategorien definiert werden, die in Anhang A und B der
      Richtlinie 3894 Blatt 2 aufgef&uuml;hrt sind und f&uuml;r die Daten zur Tierlebendmasse (GV-Wert) und zum
      Geruchsstoffemissionsfaktor vorliegen. F&uuml;r Schafe und Ziegen enth&auml;lt die VDI-Richtlinie zwar
      Geruchsstoffemissionsfaktoren, aber keine GV-Werte. In diesem Fall werden vom Abstandsrechner automatisch die
      Daten des
      <a href="http://daten.ktbl.de/gvrechner/" rel="noopener noreferrer" target="_blank">
        Gro&szlig;vieheinheitenrechners
      </a>
      des KTBL verwendet.
    </p>
    <p>
      Eine Stallquelle umfasst einzelne Stallgeb&auml;ude, Stallabteile oder
      sonstige Bereiche, in denen dieselbe Tierart und -kategorie mit
      demselben Haltungsverfahren untergebracht ist. Sind in einem
      Stallgeb&auml;ude verschiedene Tierarten oder Tierkategorien und
      Haltungsverfahren eingerichtet (z. B. Schweinezucht: Warte- und
      Deckbereich sowie Abferkel- und S&auml;ugebereich) muss jeweils eine eigene
      Stallquelle definiert werden, auch wenn die Emissionen &uuml;ber gemeinsame
      Abluftsch&auml;chte freigesetzt werden.
    </p>
    <p>
      Der Abstandrechner arbeitet mit den genehmigungsrelevanten
      Tierpl&auml;tzen. Es z&auml;hlen die tats&auml;chlich gehaltenen und
      emissionsrelevanten Tiere, z.B. Reservepl&auml;tze in der Schweinemast oder
      vorgehaltene Pl&auml;tze in der Sauenhaltung bleiben unber&uuml;cksichtigt.
    </p>
    <p>
      Anschlie&szlig;end muss das Haltungsverfahren ausgew&auml;hlt werden, womit die
      H&ouml;he der GV-spezifischen Geruchsemission nach VDI 3894 festgelegt wird.
      Die jeweilige H&ouml;he ist im Dropdown-Men&uuml; mit angegeben.
    </p>
    <p>
      Danach kann eine Emissionsminderungsma&szlig;nahme mit einem vorgegebenen
      Wirkungsgrad, beispielsweise &bdquo;Abluftreinigung, Wirkungsrad 90 %&ldquo;,
      ausgew&auml;hlt werden. Alternativ kann eine sonstige Ma&szlig;nahme festgelegt
      werden; in diesem Fall muss der Emissionsminderungsgrad selbst
      festgelegt werden.
    </p>
    <p>
      In der n&auml;chsten Zeile wird vom Abstandsrechner der tierartspezifische
      Gewichtungsfaktor nach Anhang 7 der TA Luft automatisch ausgewiesen, je
      nachdem welche Tierart und -kategorie ausgew&auml;hlt wurde:
    </p>
    <div class="ktbl-help-table-wrapper">
      <table class="ktbl-help-table">
        <thead>
          <tr>
            <th>
              <strong>
                Tierartspezifische Geruchsqualit&auml;t
              </strong>
            </th>
            <th>
              <strong>
                Gewichtungsfaktor f
              </strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Mastgefl&uuml;gel
              <br />
              (Puten, Masth&auml;hnchen, keine Enten)
            </td>
            <td>
              1,50
            </td>
          </tr>
          <tr>
            <td>
              Mastschweine
              <br />
              (bis zu einer Tierplatzzahl von 500 in qualit&auml;tsgesicherten
              Haltungsverfahren mit Auslauf und Einstreu, die nachweislich dem
              Tierwohl dienen)
            </td>
            <td>
              0,65
            </td>
          </tr>
          <tr>
            <td>
              Mastschweine, Sauen
              <br />
              (bis zu einer Tierplatzzahl von 5.000 Mastschweinen bzw. unter
              Ber&uuml;cksichtigung der jeweiligen Umrechnungsfaktoren f&uuml;r eine
              entsprechende Anzahl von Zuchtsauen)
            </td>
            <td>
              0,75
            </td>
          </tr>
          <tr>
            <td>
              Milchk&uuml;he mit Jungtieren, Mastbullen
              <br />
              (einschl. K&auml;lbermast, sofern diese zur Geruchsimmissionsbelastung nur
              unwesentlich beitr&auml;gt)
            </td>
            <td>
              0,50
            </td>
          </tr>
          <tr>
            <td>
              Pferde (ein Mistlager f&uuml;r Pferdemist ist gegebenenfalls gesondert zu
              ber&uuml;cksichtigen)
            </td>
            <td>
              0,50
            </td>
          </tr>
          <tr>
            <td>
              Milch-/Mutterschafe mit Jungtieren
              <br />
              (bis zu einer Tierplatzzahl von 1.000 und Heu/Stroh als Einstreu;
              Jungtiere bleiben bei der Bestimmung der Tierplatzzahl unber&uuml;cksichtigt.
              )
            </td>
            <td>
              0,50
            </td>
          </tr>
          <tr>
            <td>
              Milchziegen mit Jungtieren
              <br />
              (bis zu einer Tierplatzzahl von 750 und Heu/Stroh als Einstreu;
              Jungtiere bleiben bei der Bestimmung der Tierplatzzahl
              unber&uuml;cksichtigt.)
            </td>
            <td>
              0,50
            </td>
          </tr>
          <tr>
            <td>
              Sonstige Tierarten, z.B. Mastenten
            </td>
            <td>
              1,00
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p></p>
    <p>
      Um gegebenenfalls abweichende Bestimmungen und Beurteilungspraktiken
      zu erm&ouml;glichen, besteht die M&ouml;glichkeit, den vorgegebenen
      Gewichtungsfaktor durch eine Eingabe zu ver&auml;ndern.
    </p>
    <p>
      F&uuml;r die Mastschweinehaltung in Tierwohlst&auml;llen mit Auslauf und Einstreu sowie getrennten
      Funktionsbereichen aufgrund der Buchtenstrukturierung k&ouml;nnen nach der Vollzugshilfe &bdquo;Emissionsfaktoren
      f&uuml;r Ammoniak und Geruch bei alternativen Haltungsverfahren in der Mastschweinhaltung&ldquo; (
      <a href="https://www.lanuk.nrw.de/fileadmin/lanuvpubl/4_arbeitsblaetter/Arbeitsblatt_56.pdf"
        rel="noopener noreferrer" target="_blank">
        LANUK-Arbeitsblatt 56
      </a>
      ) abweichend zur VDI 3894 folgende Werte festgelegt werden:
    </p>
    <ul>
      <li>
        Tierwohlstall mit Auslauf und Einstreu (&le; 500 Tierpl&auml;tze, mind.
        1,3 m&sup2;/TP)) &ndash; 30 GE/(s &middot; GV); f = 0,65
      </li>
      <li>
        Tierwohlstall mit Auslauf und Einstreu (&gt; 500 Tierpl&auml;tze,
        mind. 1,3 m&sup2;/TP)) &ndash; 30 GE/(s &middot; GV); f = 0,75
      </li>
    </ul>
    <p>
      Folgende Mindestanforderungen bez&uuml;glich des Platzangebots pro
      Tierplatz f&uuml;r die jeweiligen Stalltypen m&uuml;ssen dabei erf&uuml;llt werden:
    </p>
    <ul>
      <li>
        Ein Au&szlig;enklimastall muss ein Platzangebot von mindestens 1,3 m&sup2;
        pro Tierplatz in der gesamten Bucht aufweisen.
      </li>
      <li>
        Ein zwangsbel&uuml;fteter Stall mit Auslauf muss ein Platzangebot von
        mindestens 1,3 m&sup2; pro Tierplatz in der gesamten Bucht inklusive Auslauf
        vorweisen. Der Auslauf muss mindestens ein Platzangebot von 0,4 m&sup2; pro
        Tierplatz bieten.
      </li>
      <li>
        Ein Au&szlig;enklimastall mit Auslauf muss ein Platzangebot von
        mindestens 1,3 m&sup2; pro Tierplatz in der gesamten Bucht inklusive Auslauf
        bieten. Der Auslauf muss, bei St&auml;llen mit einer baulichen Trennung
        zwischen Stall und Auslauf, mindestens ein Platzangebot von 0,4 m&sup2; pro
        Tierplatz bieten. Bei Au&szlig;enklimast&auml;llen mit Auslauf, bei denen es
        zwischen dem Stall und dem Auslauf keine bautechnische Trennung gibt,
        ist die Mindestgr&ouml;&szlig;e von 0,4 m&sup2; pro Tierplatz des Auslaufs nicht
        erforderlich. Diese St&auml;lle sind wie reine Au&szlig;enklimast&auml;lle zu
        betrachten.
      </li>
    </ul>
    <p>
      Auch in Bayern gibt es eine entsprechende Empfehlung f&uuml;r Tierwohlst&auml;lle in der Schweinemast (
      <a href="https://www.bestellen.bayern.de/med/8207acf1-b4a5-11f0-81ee-c3fc7d0a3316/4b0e6a70-1059-11d9-4c85-9d915831e9eb/0/lfu_luft_00216.pdf"
        rel="noopener noreferrer" target="_blank">
        Bayerisches Landesamt f&uuml;r Umwelt (2024): Immissionsschutzanforderungen bei der Umsetzung von
        Tierwohlst&auml;llen in Bayern &ndash; Schwerpunkt Schweinehaltung. Abschlussbericht
      </a>
      ).
    </p>
    <p>
      Zum Schluss sind noch die x- und y-Koordinaten in m des
      Emissionsschwerpunktes ES der Stallquelle und der quellenspezifische
      Zusatzabstand in m einzugeben.
    </p>
    <p>
      Der&nbsp;
      <strong>
        Emissionsschwerpunkt ES&nbsp;
      </strong>
      und
      der&nbsp;
      <strong>
        quellenspezifische Zusatzabstand&nbsp;d
        <sub>
          r
        </sub>
      </strong>
      , der
      die Quellenausdehnung beschreibt, bestimmen sich nach Art der r&auml;umlichen
      Ausdehnung der Quelle entsprechend Abschnitt 4.2.1 der VDI 3894/2. Dabei
      werden die Quellen immer in Aufsicht betrachtet.
    </p>
    <p>
      Bei&nbsp;
      <strong>
        Punktquellen
      </strong>
      &nbsp;(z. B. ein Abluft- oder
      Zentralabluftschacht, siehe Abb. 1) entspricht der Fl&auml;chenschwerpunkt
      der jeweiligen Punktquelle dem Emissionsschwerpunkt ES. Eine Punktquelle
      liegt vor, wenn die maximale Ausdehnung der Quell&ouml;ffnung nicht gr&ouml;&szlig;er
      als 5 m ist. F&uuml;r Punktquellen ist der quellenspezifische Zusatzabstand
      d
      <sub>
        r
      </sub>
      &nbsp;gleich null zu setzen.
    </p>
    <figure class="ktbl-help-figure">
      <img alt="Punktquellen mit Emissionsschwerpunkt ES und Zusatzabstand dr" loading="lazy"
        src="assets/img/Abbildung-1.jpg" />
      <figcaption>
        Abb. 1: Punktquellen (Emissionsschwerpunkt ES und Zusatzabstand
        d
        <sub>
          r
        </sub>
        ) (&copy; Verein Deutscher Ingenieure e. V.)
      </figcaption>
    </figure>
    <p>
      Bei r&auml;umlich ausgedehnten Quellen ist zwischen Linienquellen (z. B.
      mehrere Abluftsch&auml;chte im Dachfirst, Abb. 2) und Fl&auml;chen- und
      Volumenquellen (Abb. 3) zu unterscheiden. Vertikale Fl&auml;chenquellen (z.
      B. Offenfronstall) entsprechen bei Aufsicht einer Linienquelle.
      Volumenquellen (z. B. Liegeboxenlaufstall) entsprechen bei Aufsicht
      einer horizontalen Fl&auml;chenquelle (Grundriss).
    </p>
    <figure class="ktbl-help-figure">
      <div class="ktbl-help-image-grid ktbl-help-image-grid--two">
        <img alt="Linienquelle mit mehreren Abluftsch&auml;chten" loading="lazy" src="assets/img/Abbildung-2.jpg" />
        <img alt="Linienquelle mit Zu- und Abluft&ouml;ffnungen" loading="lazy" src="assets/img/Abbildung-2-b.jpg" />
      </div>
      <figcaption>
        Abb. 2: Linienquellen (Emissionsschwerpunkt ES und Zusatzabstand
        d
        <sub>
          r
        </sub>
        ) (&copy; Verein Deutscher Ingenieure e. V., ver&auml;ndert)
      </figcaption>
    </figure>
    <figure class="ktbl-help-figure">
      <img alt="Fl&auml;chen- und Volumenquellen mit Emissionsschwerpunkt ES und Zusatzabstand dr" loading="lazy"
        src="assets/img/Abbildung-3.jpg" />
      <figcaption>
        Abb. 3: Fl&auml;chen- und Volumenquellen (Emissionsschwerpunkt ES und
        Zusatzabstand d
        <sub>
          r
        </sub>
        ) (&copy; Verein Deutscher Ingenieure e. V.)
      </figcaption>
    </figure>
    <p>
      Bei Tierwohlst&auml;llen f&uuml;r Mastschweine mit Auslauf und Einstreu muss
      nur der Auslauf mit dem Aktivit&auml;ts- und Kotbereich als Emissionsquelle
      ber&uuml;cksichtigt werden, der Innenbereich ist nicht emissionsrelevant.
    </p>
    <p>
      Der Emissionsschwerpunkt ES liegt bei Fl&auml;chenquellen in ihrem
      Fl&auml;chenmittel und bei Linienquellen im Mittelpunkt der Quelllinie. Der
      Zusatzabstand&nbsp;
      <em>
        d
      </em>
      <sub>
        r
      </sub>
      &nbsp;ist bei r&auml;umlich ausgedehnten
      Quellen der Abstand zwischen dem Emissionsschwerpunkt ES und der am
      weitesten entfernten &auml;u&szlig;eren Begrenzung der Austrittsfl&auml;che der Emission
      in die offene Atmosph&auml;re (Abb. 2 und 3).
    </p>
    <p>
      Die Koordinaten der Emissionsschwerpunkte der einzelnen Quellen
      k&ouml;nnen &ndash; soweit vorliegend &ndash; als 7-stellige Gau&szlig;-Kr&uuml;ger-Koordinaten
      angegeben werden, z.B. X = 3476174 (Rechtswert) und Y = 5526954
      (Hochwert).
    </p>
    <p>
      Alternativ kann ein lokales Koordinatensystem &uuml;ber den Lageplan der
      Tierhaltungsanlage gelegt werden, das alle Quellen umfasst (Abb. 4).
      Zweckm&auml;&szlig;igerweise wird der Koordinatenursprung (Nullpunkt) auf den
      Emissionsschwerpunkt einer Quelle gelegt &ndash; linker Stall unten.
    </p>
    <p>
      Wenn ein Stallgeb&auml;ude mehrere Stallquellen mit verschiedenen
      Tierarten oder Tierkategorien und Haltungsverfahren umfasst (z. B.
      Schweinezucht: Warte- und Deckbereich sowie Abferkel- und S&auml;ugebereich)
      werden f&uuml;r den Emissionsschwerpunkt jeder Quelle die gleichen
      Koordinaten angesetzt, wenn die Emissionen gemeinsam freigesetzt
      werden.
    </p>
    <figure class="ktbl-help-figure">
      <img alt="Lokales Koordinatensystem zur Bestimmung der Emissionsschwerpunkte zweier St&auml;lle" loading="lazy"
        src="assets/img/Abbildung-4.jpg" />
      <figcaption>
        Abb. 4: Beispiel zur Bestimmung der Koordinaten der
        Emissionsschwerpunkte zweier St&auml;lle in einem lokalen Koordinatensystem
        mit den Emissionsschwerpunkten (80/100) und (0/0) (&copy; Verein Deutscher
        Ingenieure e. V.)
      </figcaption>
    </figure>
    <h4 id="3-2-2-flaechenquellen">
      3.2.2 Fl&auml;chenquellen
    </h4>
    <p>
      Fl&auml;chenquellen k&ouml;nnen f&uuml;r verschiedene Arten von
      geruchsstoffemittierenden Futter- und Dunglagern festgelegt werden, die
      in Anhang B, Tabelle B2 der Richtlinie 3894 Blatt 2 aufgef&uuml;hrt sind.
    </p>
    <p>
      Anschlie&szlig;end k&ouml;nnen als emissionsmindernde Ma&szlig;nahme verschiedene
      Arten der G&uuml;llebeh&auml;lterabdeckung mit einem vorgegebenen Wirkungsgrad, z.
      B. &bdquo;Strohh&auml;cksel, Wirkungsgrad 80 %) ausgew&auml;hlt werden. Falls eine nicht
      vorgeschlagene Ma&szlig;nahme eingesetzt wird, kann diese als &bdquo;Sonstige
      Ma&szlig;nahme&ldquo; ber&uuml;cksichtigt werden; in diesem Fall muss der
      Emissionsminderungsgrad im n&auml;chsten Schritt selbst festgelegt
      werden.
    </p>
    <p>
      In der n&auml;chsten Zeile wird der tierartspezifische Gewichtungsfaktor f
      nach Anhang 7 der TA Luft automatisch ausgewiesen. Der Faktor h&auml;ngt von
      der Art der Fl&auml;chenquelle ab, die oben ausgew&auml;hlt wurde. Bei
      Flachsiloanlagen, die Bestandteil einer Rinderhaltungsanlage sind, wird
      &ndash; entsprechend der Praxis &ndash; f&uuml;r den Gewichtungsfaktor standardm&auml;&szlig;ig der
      Wert f&uuml;r Rinder in H&ouml;he von 0,5 vorgegeben. F&uuml;r Dunglager, die sich auf
      dem Gel&auml;nde der Tierhaltungsanlage befinden, wird der Gewichtungsfaktor
      der jeweiligen Tierart vorgegeben, Beispiele: 0,75 bei Lagerung von
      Schweineg&uuml;lle oder -festmist, 0,5 bei Lagerung von Rinderg&uuml;lle oder
      -festmist, 1,5 bei Lagerung von Festmist aus der Gefl&uuml;gelmast, 1 bei
      Trockenkotlagern (TS &gt; 55 %) der Legehennenhaltung. Dieser Faktor
      kann bei Bedarf ge&auml;ndert werden.
    </p>
    <p>
      In jedem Fall sind m&ouml;gliche l&auml;nderspezifischen Besonderheiten zu
      beachten. Im Fall von abweichenden Bestimmungen, besteht hier die
      M&ouml;glichkeit, den vorgegebenen Wert durch eine Eingabe zu ver&auml;ndern.
    </p>
    <p>
      Im n&auml;chsten Schritt sind bei Festmist- und Kotlagern L&auml;nge und
      Breite, bei Flachsilos Breite und H&ouml;he der Anschnittsfl&auml;che und bei
      G&uuml;llebeh&auml;ltern der Durchmesser einzugeben. Diese Angaben werden
      ben&ouml;tigt, um die Geruchsstoffemissionen zu berechnen, die von der
      emissionsaktiven Fl&auml;che abh&auml;ngen.
    </p>
    <p>
      Zum Schluss sind noch die x- und y-Koordinaten in m des
      Emissionsschwerpunktes ES der Fl&auml;chenquelle einzugeben. Dabei ist wie
      bei Stallquellen vorzugehen.
    </p>
    <p>
      Der quellenspezifische Zusatzabstand d
      <sub>
        r
      </sub>
      &nbsp;wird aus den
      Eingaben der geometrischen Abmessungen automatisch berechnet.
    </p>
    <h4 id="3-2-3-sonstige-quellen">
      3.2.3 Sonstige Quellen
    </h4>
    <p>
      Unter &bdquo;Sonstige Quellen&ldquo; k&ouml;nnen beliebige Quellen definiert werden.
      Sie sind in der Richtlinie VDI 3894 Blatt 2 nicht als eigene Kategorie
      beschrieben. Das Abstandsmodell der Richtlinie ist jedoch unabh&auml;ngig von
      der Art der Geruchsquelle universell g&uuml;ltig, da es auf der Verwendung
      von Geruchsstoffemissionen beruht. Daher kann die Abstandsregelung
      grunds&auml;tzlich auch auf andere Arten von Geruchsstoffemittenten wie
      beispielsweise Biogasanlagen angewendet werden. Voraussetzung ist, dass
      f&uuml;r die jeweilige Quelle eine Geruchsstoffemission in GE/s angegeben
      werden kann.
    </p>
    <p>
      Die Vorschriften zur Ber&uuml;cksichtigung der Quellengeometrie sowie alle
      anderen, sich auf Stallanlagen beziehenden Regelungen, m&uuml;ssen f&uuml;r die
      Anwendung der sonstigen Quelle im Einzelfall gepr&uuml;ft und eventuell
      angepasst werden.
    </p>
    <p>
      Nach Eingabe der Geruchsstoffemission ist der Gewichtungsfaktor f
      nach Anhang 7 der TA Luft festzulegen; standardm&auml;&szlig;ig ist der Wert 1
      vorgegeben. Die Festlegung des Emissionsschwerpunktes ES der Quelle und
      die Bestimmung seiner Koordinaten sowie die Bemessung des
      Zusatzabstandes d
      <sub>
        r
      </sub>
      &nbsp;erfolgen wie f&uuml;r Stallquellen
      beschrieben.
    </p>
    <h4 id="3-2-4-zusatzabstand-und-gewichtungsfaktor-pruefen">
      3.2.4 Zusatzabstand und Gewichtungsfaktor pr&uuml;fen
    </h4>
    <p>
      Aus den Angaben zu den einzelnen Emissionsquellen werden die
      Gesamtemission und die &ouml;rtliche Lage des Emissionsschwerpunktes der
      gesamten Tierhaltungsanlage berechnet und unterhalb der &Uuml;bersicht zu den
      Emissionsquellen angezeigt.
    </p>
    <p>
      Der Emissionsschwerpunkt der gesamten Tierhaltungsanlage ist der
      sogenannte Abstandsbemessungspunkt AP nach Richtlinie VDI 3894 Blatt 2,
      der sich als Fl&auml;chenschwerpunkt der Emissionsschwerpunkte der einzelnen
      Quellen ergibt, die nach ihrer Quellst&auml;rke gewichtet werden. Der
      Abstandsbemessungspunkt ist Ausgangspunkt f&uuml;r die Bemessung des
      Richtlinienabstandes einer Tierhaltungsanlage gegen&uuml;ber anderen
      Nutzungen. Besteht eine Tierhaltungsanlage nur aus einer Quelle, ist der
      Emissionsschwerpunkt ES dieser Quelle gleichzeitig
      Abstandsbemessungspunkt AP.
    </p>
    <p>
      Im Weiteren k&ouml;nnen die aus den Angaben automatisch berechneten Werte
      f&uuml;r den Zusatzabstand d
      <sub>
        r
      </sub>
      &nbsp;der gesamten Tierhaltungsanlage und
      den tierartspezifischen Gewichtungsfaktor f der Gesamtanlage gepr&uuml;ft und
      gegebenenfalls angepasst werden.
    </p>
    <p>
      <strong>
        Hinweis:
      </strong>
      &nbsp;Wurden die Werte im Rahmen einer Berechnung
      angepasst, so wird diese Korrektur&nbsp;beim Export der Daten&nbsp;mit
      abgespeichert. Wenn die Berechnung sp&auml;ter&nbsp;wieder importiert
      und&nbsp;bearbeitet wird und&nbsp;dabei&nbsp;Emissionsquellen ver&auml;ndert oder neu
      festgelegt werden,&nbsp;werden diese Werte&nbsp;f&uuml;r die Gesamtanlage&nbsp;neu
      berechnet. Sie&nbsp;m&uuml;ssen&nbsp;daher&nbsp;gepr&uuml;ft und eventuell korrigiert werden.
    </p>
    <p>
      Der&nbsp;quellenspezifische
      <strong>
        Zusatzabstand&nbsp;
        <em>
          d
          <sub>
            r
          </sub>
        </em>
        &nbsp;der
        Gesamtanlage
      </strong>
      &nbsp;ber&uuml;cksichtigt den Einfluss der horizontalen
      Ausdehnung der Emissionsquellen auf den Richtlinienabstand. Er h&auml;ngt von
      den Abst&auml;nden der verschiedenen Quellen untereinander und der Ausdehnung
      der einzelnen Quellen ab. Er ist so zu bemessen, dass er als Radius um
      den Emissionsschwerpunkt der gesamten Tierhaltungsanlage
      (Abstandsbemessungspunkt ES
      <sub>
        ges
      </sub>
      ) alle Emissionsquellen
      einschlie&szlig;t (Abb. 5). Auf diese Art und Weise wird verhindert, dass der
      Richtlinienabstand die Quelle der betrachteten Anlage schneidet.
    </p>
    <figure class="ktbl-help-figure">
      <img alt="Bemessung des Zusatzabstandes einer Gesamtanlage mit verschiedenen Quellen" loading="lazy"
        src="assets/img/Abbildung-5.jpg" />
      <figcaption>
        Abb. 5: Bemessung des Zusatzabstandes einer Gesamtanlage mit
        verschiedenen Quellen (VDI 3894 Blatt 2 (&copy; Verein Deutscher Ingenieure
        e. V., ver&auml;ndert))
      </figcaption>
    </figure>
    <p>
      Der bei Anwendung des Abstandsrechners vorgegebene Wert wird
      abweichend von der VDI 3894 Blatt 2 entsprechend folgender
      Rechenvorschrift automatisch aus den Koordinaten des
      Emissionsschwerpunktes der gesamten Tierhaltungsanlage (X
      <sub>
        ES
      </sub>
      ,
      Y
      <sub>
        ES
      </sub>
      ) und der Emissionsschwerpunkte der Einzelquellen i
      (X
      <sub>
        i
      </sub>
      , Y
      <sub>
        i
      </sub>
      ) sowie dem quellenspezifischen
      Zusatzabstand d
      <sub>
        rQ,i
      </sub>
      &nbsp;der jeweiligen Einzelquelle als gr&ouml;&szlig;te
      vorkommende Abstandssumme berechnet:
    </p>
    <div class="ktbl-help-formula">
      <span>
        <em>
          d
        </em>
        <sub>
          r
        </sub>
        =
        <em>
          max
        </em>
        (
        <em>
          d
        </em>
        <sub>
          r,i
        </sub>
        ) mit
      </span>
      <img alt="Rechenformel f&uuml;r den quellenspezifischen Zusatzabstand" loading="lazy"
        src="assets/img/formel.png" />
    </div>
    <p>
      Im Vergleich zur Richtlinie VDI 3894 Blatt 2 wird mit dieser
      Rechenvorschrift der Zusatzabstand d
      <sub>
        r,i
      </sub>
      &nbsp; &uuml;bersch&auml;tzt, wenn
      sich die Linienquelle oder die Diagonale der Fl&auml;chenquelle nicht in
      Verl&auml;ngerung der Verbindung zwischen Emissionsschwerpunkt der
      Gesamtanlage und Emissionsschwerpunkt der jeweiligen Quelle ausdehnt.
      Diese Konvention hat eine gew&uuml;nscht konservative Beurteilung der
      Immissionssituation zur Folge. Anhand der Planunterlagen kann dies
      &uuml;berpr&uuml;ft und, falls notwendig, durch Korrektur des Wertes ausgeglichen
      werden.
    </p>
    <p>
      Der f&uuml;r die Bewertung von Geruchsimmissionen
      relevante&nbsp;
      <strong>
        Gewichtungsfaktor f
      </strong>
      &nbsp;der Gesamtanlage ist nach
      Anhang 7 der TA Luft bei unterschiedlichen Faktoren (Tierarten) aus den
      Einzelfaktoren&nbsp;f
      <sub>
        i
      </sub>
      &nbsp;und gewichtet entsprechend dem jeweiligen
      Immissionsbeitrag (Geruchsstundenh&auml;ufigkeit) der Emissionsquellen zu
      ermitteln. Dies ist &ndash; anders als bei Ausbreitungsrechnungen &ndash; im Rahmen
      der Abstandsbeurteilung nicht m&ouml;glich. In diesen F&auml;llen muss zur
      Vereinfachung der Berechnung ein tierartspezifischer
      Bewertungsfaktor&nbsp;f&nbsp;entsprechend dem maximal auftretenden
      Wert&nbsp;f
      <sub>
        max
      </sub>
      &nbsp;gew&auml;hlt werden. Diese Konvention hat ebenfalls eine
      konservative Beurteilung der Immissionssituation zur Folge.
    </p>
    <h3
      id="3-3-winddaten-und-gebietskategorie-angaben-zur-windhaeufigkeit-und-zulaessigen-geruchsstundenhaeufigkeit-am-standort">
      3.3 Winddaten und Gebietskategorie: Angaben zur Windh&auml;ufigkeit und zul&auml;ssigen
      Geruchsstundenh&auml;ufigkeit am Standort
    </h3>
    <p>
      Nach den Emissionsquellen im Reiter &bdquo;Betrieb&ldquo; m&uuml;ssen im Reiter
      &bdquo;Winddaten und Gebietskategorie&ldquo; die f&uuml;r die Immissionsbeurteilung
      ben&ouml;tigten Daten zur Windrichtungsh&auml;ufigkeit am Standort und den
      Nutzungen im Umfeld der Tierhaltungsanlage und deren Schutzbed&uuml;rftigkeit
      in Bezug auf Geruchsimmissionen (Gebietskategorien) festgelegt
      werden.
    </p>
    <p>
      Die Angaben sind f&uuml;r einzelne Himmelsrichtungen, f&uuml;r mehrere
      aneinandergrenzende Himmelsrichtungen (Sektoren) oder alle
      Himmelsrichtungen m&ouml;glich. Sie sind zumindest f&uuml;r die Richtungssektoren
      erforderlich, in denen &ndash; ausgehend vom Emissionsschwerpunkt ES der
      Gesamtanlage &ndash; schutzbed&uuml;rftige Nutzungen liegen, die hinsichtlich des
      Immissionsschutzes beurteilt werden sollen.
    </p>
    <p>
      Bei der Windrichtungsh&auml;ufigkeit ist zu beachten, dass sich die
      verf&uuml;gbaren Daten immer auf die Himmelsrichtung beziehen, aus der der
      Wind weht. F&uuml;r die Beurteilung einer Nutzung in einer bestimmten
      Transportrichtung ist daher immer die Windrichtungsh&auml;ufigkeit
      heranzuziehen, die der Transportrichtung + 180&deg; entspricht. Die
      Windrichtungsh&auml;ufigkeit ist in Promille anzugeben.
    </p>
    <p>
      Die hinsichtlich der Geruchsimmissionen in Transportrichtung zu
      beurteilenden Nutzungen sind einer bestimmten Gebietskategorie nach
      Baunutzungsverordnung bzw. Anhang 7 der TA Luft, z. B.
      Wohn-/Mischgebiete, Dorfgebiete oder Au&szlig;enbereich, zuzuordnen. In diesen
      Gebieten sind nach TA Luft oder Rechtsprechung unterschiedliche
      Immissionswerte f&uuml;r Geruchsstundenh&auml;ufigkeiten angegeben in Prozent
      maximal zul&auml;ssig. Die unterschiedlichen Gebietskategorien mit ihren
      Immissionswerten k&ouml;nnen wie vorgegeben ausgew&auml;hlt und festgelegt werden.
      Wird &bdquo;Sonstiges (Geruchsstundenh&auml;ufigkeit festlegen)&ldquo; gew&auml;hlt, kann ein
      von diesen Vorgabewerten abweichender Immissionswert
      (Geruchsstundenh&auml;ufigkeit) definiert werden. Der Geltungsbereich der
      Richtlinie VDI 3894 Blatt 2 ist dabei zu beachten.
    </p>
    <p>
      Mithilfe des Buttons &bdquo;Schnelleinstellungen&ldquo; ist es m&ouml;glich, die
      Eingabe der Daten zu vereinfachen. Es k&ouml;nnen bestimmte
      Windrichtungssektoren festgelegt werden, f&uuml;r die eine einheitliche
      Windh&auml;ufigkeit und/oder Gebietskategorie vorgegeben wird.&nbsp;Dabei ist
      jedoch zu beachten, dass sich diese Gebiete in Transportrichtung
      befinden, also um + 180&deg; gedreht.&nbsp;Auf diese Art und Weise kann f&uuml;r
      ausgew&auml;hlte Sektoren schnell eine pauschalierte Abstandsbeurteilung
      durchgef&uuml;hrt werden. Mit den standardm&auml;&szlig;ig aktivierten Best&auml;tigungshaken
      kann festgelegt werden, ob die Angaben in den Schnelleinstellungen f&uuml;r
      die Windh&auml;ufigkeit oder Gebietskategorie ber&uuml;cksichtigt werden sollen,
      wodurch bereits eingegebene oder importierte Winddaten &uuml;berschrieben
      werden.
    </p>
    <p>
      Eine vollst&auml;ndige Abstandsbeurteilung in allen Himmelsrichtungen ist
      nur auf Grundlage einer kompletten 36-teiligen
      Windrichtungsh&auml;ufigkeitsverteilung m&ouml;glich, die f&uuml;r den jeweiligen
      Standort repr&auml;sentativ ist. Diese kann vom DWD oder anderen
      kommerziellen Anbietern bezogen werden. In einigen Bundesl&auml;ndern sind
      entsprechende Daten auch im Internet verf&uuml;gbar (z. B.&nbsp;
      <a href="http://windrosen.hessen.de/viewer.htm" rel="noopener noreferrer" target="_blank">
        <u>
          Windrosenatlas
          Hessen
        </u>
      </a>
      ).
    </p>
    <p>
      Die Daten k&ouml;nnen von Hand eingegeben, aus einer AKS-Datei
      (Ausbreitungsklassenstatistik &ndash; AKS) oder aus einer Datei im CSV-Format
      importiert werden (Winddaten importieren). AKS-Dateien m&uuml;ssen dem
      Standardformat entsprechen: Der Kopf muss aus 5 Zeilen bestehen, deren
      Eintr&auml;ge jedoch beliebig sein k&ouml;nnen. Ab der sechsten Zeile m&uuml;ssen die
      H&auml;ufigkeiten der F&auml;lle in Spalten von 10 bis 360 Grad Windrichtung mit
      einer Abstufung von 10 Grad stehen. CSV-Dateien k&ouml;nnen mit jedem
      Tabellenkalkulationsprogramm (z. B. Excel: &bdquo;Datei &ndash; Speichern unter &ndash;
      Dateityp: CSV&ldquo;) erzeugt werden. Eine CSV-Vorlagendatei f&uuml;r den
      Winddatenimport kann unter dem Button &bdquo;Vorlagen-Download&ldquo;
      heruntergeladen werden.
    </p>
    <p>
      In der Online-Anwendung von Hand eingegebene oder ge&auml;nderte
      Windh&auml;ufigkeiten k&ouml;nnen im Men&uuml; &bdquo;Winddaten exportieren&ldquo; im CSV-Format
      lokal gespeichert und f&uuml;r andere Berechnungen weiterverwendet
      werden.
    </p>
    <p>
      <strong>
        Wenn keine Daten verf&uuml;gbar sind, kann wie im Folgenden
        beschrieben, vorgegangen werden.
      </strong>
    </p>
    <p>
      F&uuml;r erste, grobe Absch&auml;tzungen des Richtlinienabstands kann auf das
      Vorhandensein einer standortspezifischen Windrichtungsh&auml;ufigkeit oftmals
      verzichtet und pauschal in allen Richtungen eine H&auml;ufigkeit von 60 &permil;,
      die dem oberen Rand des G&uuml;ltigkeitsbereiches der Abstandsregelung
      entspricht, angesetzt werden.
    </p>
    <p>
      Sollte jedoch f&uuml;r einen nahen Standort eine Windrose verf&uuml;gbar sein,
      kann auch die gr&ouml;&szlig;te Windrichtungsh&auml;ufigkeit (in Hauptwindrichtung)
      dieses Standorts mit einem Sicherheitsaufschlag von 20 % f&uuml;r alle
      Windrichtungen herangezogen werden. Das bedeutet beispielsweise, dass
      die maximale Windrichtungsh&auml;ufigkeit von 60 &permil; (Hauptwindrichtung) eines
      nahen Standorts dahingehend ver&auml;ndert wird, dass die
      Windrichtungsh&auml;ufigkeit f&uuml;r alle 36 Richtungen mit 72 &permil; (60 &permil; + 12 &permil;; 12
      &permil; entsprechen 20 % der H&auml;ufigkeit) angenommen wird.
    </p>
    <p>
      Wenn eine Windrose eines nahen Standorts nicht verf&uuml;gbar ist, kann in
      der Regel mit einer Windrichtungsh&auml;ufigkeit von 120 &permil; eine erste
      pauschale Abstandssch&auml;tzung erfolgen. Alternativ kann bei einem ebenen
      Standort und einer breiten Tallage eine Windrichtungsh&auml;ufigkeit von 70 &permil;
      und bei engen Tallagen eine H&auml;ufigkeit von 150 &permil; angesetzt werden. Bei
      dieser Vorgangsweise ist zu beachten, dass dies keine
      richtlinienkonforme Berechnung darstellt.
    </p>
    <p>
      Bei bekannten Windrichtungsh&auml;ufigkeiten von &uuml;ber 60 &permil; und damit
      Werten au&szlig;erhalb des Geltungsbereiches der Richtlinie kann f&uuml;r eine
      erste Einsch&auml;tzung der Geruchsimmissionssituation der Richtlinienabstand
      dennoch berechnet werden. Dabei ist jedoch zu beachten, dass die
      errechneten Abst&auml;nde nicht immer konservative Werte liefern: Die
      Wahrscheinlichkeit f&uuml;r eine Untersch&auml;tzung nimmt mit steigenden
      Windrichtungsh&auml;ufigkeiten zu.
    </p>
    <p>
      In orografisch gegliedertem Gel&auml;nde (bergig, h&uuml;gelig) kann im
      Einzelfall eine vorliegende Windrichtungsh&auml;ufigkeitsverteilung aus der
      Umgebung &uuml;berschl&auml;gig der Orografie angepasst werden
    </p>
    <p>
      F&uuml;r eine sichere Beurteilung von Vorhaben sind standortbezogene Daten
      jedoch unabdingbar.
    </p>
    <h3 id="3-4-ergebnisse-der-abstandsberechnung">
      3.4 Ergebnisse der Abstandsberechnung
    </h3>
    <p>
      Wenn die Eingaben erfolgt sind, werden die Berechnungen und
      Ergebnisse der durchgef&uuml;hrten Berechnung angezeigt. In den
      Ergebnistabellen werden Werte au&szlig;erhalb des Geltungsbereichs der
      Richtlinie (z.B. Windh&auml;ufigkeit &gt; 60 &permil; oder Abst&auml;nde &lt; 50 m) in
      roter Schrift hervorgehoben.
    </p>
    <p>
      In der Ergebnistabelle bezeichnet R den Richtlinienabstand, der sich
      f&uuml;r die nach Anhang 7 der TA Luft unbewertete Geruchsstundenh&auml;ufigkeit
      ergibt. Unter R` ist der Abstand angegeben, der sich unter
      Ber&uuml;cksichtigung des tierartspezifischen Gewichtungsfaktors f f&uuml;r die
      bel&auml;stigungsrelevante Geruchsstundenh&auml;ufigkeit ergibt und der f&uuml;r die
      Beurteilung relevant ist.
    </p>
    <p>
      Die jeweilige Berechnung mit den Daten und Ergebnissen kann als PDF-
      oder Excel-Datei zur Dokumentation der Berechnung oder zur
      Weiterverarbeitung heruntergeladen und lokal gespeichert werden.
    </p>
    <p>
      Die Windrose und das Abstandsdiagramm k&ouml;nnen im Bildformat PNG (mit
      transparentem Hintergrund) heruntergeladen und zur Weiterverarbeitung
      lokal gespeichert werden.
    </p>
  </article>
</div>

schauen hier ob das passt mit dem abstand nach unten

<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-floating-container-ohne-rand-wrapper">
  <div class="ktbl-floating-content">
    <button (click)="onClickUp()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button="" type="button">
      <i class="fas fa-chevron-up ktbl-icon-vertical-align">
      </i>
    </button>
    <button (click)="onClickDown()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button="" type="button">
      <i class="fas fa-chevron-down ktbl-icon-vertical-align">
      </i>
    </button>
  </div>
</div>